// extracted by mini-css-extract-plugin
export var addButton = "_oa-0";
export var border = "_oa-8";
export var check = "_oa-h";
export var danger = "_oa-6";
export var dropdownContainer = "_oa-1";
export var editModalBody = "_oa-j";
export var footerContainer = "_oa-i";
export var fullWidth = "_oa-a";
export var hide = "_oa-9";
export var icon = "_oa-3";
export var input = "_oa-7";
export var inputFlex = "_oa-b";
export var inputWrapper = "_oa-c";
export var manualFocus = "_oa-5";
export var optionButton = "_oa-4";
export var pillWrapper = "_oa-e";
export var pointer = "_oa-2";
export var showOverflow = "_oa-f";
export var tagsFlex = "_oa-d";
export var xButton = "_oa-g";